export function getCadFileModelId(value) {
  return (
    value?.cadFileModelId ??
    value?.cadFileModelID ??
    value?.cad_file_model_id ??
    value?.cadFileModel?.id ??
    value?.cadfilemodel?.cadFileModelId ??
    value?.cadfilemodels?.[0]?.cadFileModelId ??
    value?.object?.cadFileModelId ??
    value?.object?.cadFileModelID ??
    value?.id ??
    null
  );
}

export function getReconstructionId(value) {
  return (
    value?.reconstructionID ??
    value?.reconstructionId ??
    value?.reconstruction_id ??
    value?.cadfilemodel?.reconstructionID ??
    value?.cadfilemodels?.[0]?.reconstructionID ??
    value?.object?.reconstructionID ??
    value?.object?.reconstructionId ??
    value?.reconstructionData?.reconstructionID ??
    null
  );
}

export function isViewerFileSource(value) {
  return Boolean(
    value?.taskId &&
    (getCadFileModelId(value) ||
      getReconstructionId(value) ||
      value?.path ||
      value?.filePath),
  );
}
